module.exports = __webpack_public_path__ + "img/image-4.66b7ea7c.webp";